import { render, staticRenderFns } from "./FindThePairs.vue?vue&type=template&id=28293aa6&"
import script from "./FindThePairs.vue?vue&type=script&lang=js&"
export * from "./FindThePairs.vue?vue&type=script&lang=js&"
import style0 from "./FindThePairs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FindThePairs.vue"
export default component.exports